import BaseModel from './BaseModel'

export default class Subscriber extends BaseModel {
}
